// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4359":"abcc1ee8","8362":"458acb3d","9510":"458acb3d"}[chunkId] + ".chunk.css";
};